import { Component } from 'react';
import { FormGroup, Label, Input, FormFeedback, InputGroupText } from 'reactstrap';
import PropTypes from 'prop-types';
// import { InputErrorType } from 'types/CommonTypes';

import withRequired from './withRequired';

class InputPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isVisible: false,
    };
  }

  toggleVisibility() {
    this.setState((prevState) => ({
      isVisible: !prevState.isVisible,
    }));
  }

  render() {
    let errorMgs;

    if (this.props.errors) {
      this.props.errors.details.forEach((error) => {
        if (error.fieldName === this.props.name) {
          errorMgs = error.messages;
        }
      });
    }

    return (
      <FormGroup>
        {this.props.label ? (
          <Label for={this.props.name} className="small">
            {this.props.required && this.props.showAsterisk ? <sup>*</sup> : ''}
            {this.props.label}
          </Label>
        ) : (
          ''
        )}
        <div className={`input-group-with-addon ${errorMgs ? 'is-invalid' : ''}`}>
          <Input
            type={this.state.isVisible ? 'text' : 'password'}
            name={this.props.name}
            autoComplete={this.props.autoComplete}
            value={this.props.value}
            onChange={this.props.handleChange}
            required={this.props.required}
            // invalid={errorMgs ? true : false}
          />
          <InputGroupText onClick={() => this.toggleVisibility()}>
            <span>
              {this.state.isVisible ? (
                <img src={this.props.iconEyeSlash} className="svg-inline" alt="" />
              ) : (
                <img src={this.props.iconEye} className="svg-inline" alt="" />
              )}
            </span>
          </InputGroupText>
        </div>
        <FormFeedback className="ps-0 mt-1">
          {errorMgs
            ? errorMgs.map((message, k) => (
                <li key={k} style={{ listStyle: 'none' }}>
                  {message}
                </li>
              ))
            : ''}
        </FormFeedback>
      </FormGroup>
    );
  }
}

InputPassword.propTypes = {
  // errors: InputErrorType,
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  autoComplete: PropTypes.string,
  required: PropTypes.bool,
  handleChange: PropTypes.func.isRequired,
  value: PropTypes.string,
  validationErrors: PropTypes.object, //eslint-disable-line
  showAsterisk: PropTypes.bool,
  iconEye: PropTypes.string.isRequired,
  iconEyeSlash: PropTypes.string.isRequired,
};

InputPassword.defaultProps = {
  errors: undefined,
  label: null,
  autoComplete: 'current-password',
  required: false,
  value: undefined,
  validationErrors: undefined,
  showAsterisk: true,
};

export default withRequired(InputPassword);
